<template>
  <ui-dropdown-range
    :min-label="$t(minLabel)"
    :min-options="minOptions"
    :max-label="$t(maxLabel)"
    :max-options="maxOptions"
    :disabled="isLoading"
    :data-test-id="`emh-side-filters-range-dropdowns__${rangeName}`"
    @select-min-option="selectMinOption"
    @select-max-option="selectMaxOption"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EmhSideFiltersRangeDropdowns',
});
</script>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import UiDropdownRange from '@dh-io-emh/ui/src/form/dropdown/dropdownRange/DropdownRange.vue';
import { infuse } from '@dh-io-emh/shared/src/ioc-config';
import { SupportedMarket } from '@dh-io-emh/shared/src/utils/format-to-market-specific-currency.util';
import ProductFilterSlider from '@dh-io-emh/shared/src/models/product-filter/product-filter-slider.model';
import { useStepRangeDropdownOptions } from '../../composables/range-dropdown-options.composable.com';

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  filter: {
    type: Object as PropType<ProductFilterSlider>,
    required: true,
  },
  step: {
    type: Number,
    default: undefined,
  },
  locale: {
    type: String as PropType<SupportedMarket>,
    default: undefined,
  },
  formatCurrencyLabels: {
    type: Boolean,
    default: false,
  },
  rangeName: {
    type: String,
    default: 'side-filters-range',
  },
  minLabel: {
    type: String,
    default: 'dcp.sideFilters.rangeDropdown.fromLabel',
  },
  maxLabel: {
    type: String,
    default: 'dcp.sideFilters.rangeDropdown.toLabel',
  },
});

const emit = defineEmits(['change']);

const { filter, step, locale, formatCurrencyLabels } = toRefs(props);
const { locale: configLocale } = infuse('config');

const selectedLocale = computed(() => locale?.value ?? (configLocale as SupportedMarket));

const { minOptions, maxOptions, selectMinOption, selectMaxOption } = useStepRangeDropdownOptions({
  filter,
  step,
  emit,
  locale: selectedLocale,
  formatCurrencyLabels,
});
</script>

<style lang="scss" scoped>
.emh-side-filters-price-category {
  &__price-type-toggle {
    @include wb-spacing('margin-bottom', 's');
  }
}
</style>
